import React from 'react';
import { useCart } from '../context/CartContext';
import { Trash2, Plus, Minus, CreditCard } from 'lucide-react';

const CartPage = () => {
  const { cartItems, removeFromCart, updateQty, cartTotal } = useCart();

  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <h2 className="text-3xl font-bold mb-10 text-accentBlue">Your Shopping Cart</h2>
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        {/* Left Side - Cart Items [cite: 160] */}
        <div className="lg:col-span-2 space-y-4">
          {cartItems.length === 0 ? (
            <div className="p-10 bg-white/5 border border-dashed border-white/20 rounded-3xl text-center text-gray-500">
              Your cart is empty. Start shopping!
            </div>
          ) : (
            cartItems.map((item) => (
              <div key={item.id} className="bg-white/5 border border-white/10 p-4 rounded-3xl flex items-center gap-4">
                <div className="w-20 h-20 bg-white/10 rounded-2xl flex-shrink-0"></div>
                <div className="flex-1">
                  <h4 className="font-bold">{item.title}</h4>
                  <p className="text-accentBlue font-bold text-sm">Rs. {item.price}</p>
                </div>
                {/* Quantity Controls [cite: 160] */}
                <div className="flex items-center gap-3 bg-darkBg border border-white/10 p-2 rounded-xl">
                  <button onClick={() => updateQty(item.id, -1)} className="hover:text-accentBlue"><Minus size={16} /></button>
                  <span className="w-5 text-center font-bold">{item.qty}</span>
                  <button onClick={() => updateQty(item.id, 1)} className="hover:text-accentBlue"><Plus size={16} /></button>
                </div>
                <button onClick={() => removeFromCart(item.id)} className="text-red-500/50 hover:text-red-500 p-2 transition">
                  <Trash2 size={20} />
                </button>
              </div>
            ))
          )}
        </div>

        {/* Right Side - Checkout Form [cite: 161-167] */}
        <div className="bg-white/5 border border-white/10 p-8 rounded-[40px] backdrop-blur-xl h-fit">
          <h3 className="text-xl font-bold mb-6 flex items-center gap-2">
            <CreditCard size={20} className="text-accentBlue" /> Checkout Details
          </h3>
          
          <form className="space-y-4">
            <input type="text" placeholder="Full Name" className="w-full bg-darkBg border border-white/10 p-3 rounded-xl focus:border-accentBlue outline-none text-sm" required />
            <input type="email" placeholder="Email Address" className="w-full bg-darkBg border border-white/10 p-3 rounded-xl focus:border-accentBlue outline-none text-sm" required />
            <input type="text" placeholder="Mobile Number" className="w-full bg-darkBg border border-white/10 p-3 rounded-xl focus:border-accentBlue outline-none text-sm" required />
            <textarea placeholder="Delivery Address" className="w-full bg-darkBg border border-white/10 p-3 rounded-xl focus:border-accentBlue outline-none text-sm h-24" required></textarea>
            
            <select className="w-full bg-darkBg border border-white/10 p-3 rounded-xl focus:border-accentBlue outline-none text-sm">
              <option value="cod">Cash on Delivery</option>
              <option value="bank">Bank Transfer</option>
            </select>

            <div className="pt-6 border-t border-white/10 mt-6">
              <div className="flex justify-between mb-4">
                <span className="text-gray-400">Total Amount</span>
                <span className="text-2xl font-bold text-accentBlue">Rs. {cartTotal.toLocaleString()}.00</span>
              </div>
              <button type="submit" className="w-full py-4 bg-accentBlue text-black rounded-2xl font-bold hover:scale-[1.02] transition-transform">
                Confirm Order
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CartPage;